// extracted by mini-css-extract-plugin
module.exports = {"modal":"Popup_modal__iGn9z","header":"Popup_header__2c83k","content":"Popup_content__16Iwr","actions":"Popup_actions__3Oi_Q","close":"Popup_close__2-DwJ"};